import { query, destroy, post, put, patch } from '@/services/api/backendGateway'

const FOLDER_API = '/folder/'

export async function fetchFolderById(folderId) {
  return query(FOLDER_API, { id: folderId })
}

export async function fetchUserFolders(userId) {
  return (await query(FOLDER_API, { user: userId })) || []
}

export async function fetchFoldersByCategory({ categoryId, userId = null }) {
  const params = categoryId != null ? { category: categoryId } : {}
  return (await query(FOLDER_API, params)) || []
}

export function updateFolder(payload) {
  return put(FOLDER_API, payload)
}

export function patchFolder(payload) {
  return patch(FOLDER_API, payload)
}

export function createFolder(payload) {
  return post(FOLDER_API, payload)
}

export function deleteFolderById(folderId) {
  return destroy(FOLDER_API, { id: folderId })
}

export function sendFolderInvitations(folderId, emails) {
  return post('/folder/invite/', { folder_id: folderId, emails: JSON.stringify(emails) })
}
